import {h, Fragment} from "preact"
import { useCustomConfig } from '../../hooks/useCustomConfig'

const youtubeAllowances = [
    'accelerometer',
    'clipboard-write',
    'encrypted-media',
    'gyroscope',
    'picture-in-picture'
]

const vimeoAllowances = [
    'fullscreen',
    'picture-in-picture'
]

const autoPlayVideos = true;

const FeaturedItemImage = ({ image }) => {
    const { title, src, width, height } = image
    return (
        <div class="media-wrap ease-animation-slow">
            <img
                className="media ease-animation-slow"
                src={src}
                alt={title}
                width={width}
                height={height}
                loading="lazy"
            />
        </div>
    )
}

const FeaturedItemVideo = ({ video }) => {
    return (
        <video class="media mp4 lazyload" playsinline muted={autoPlayVideos} loop={autoPlayVideos} data-autoplay={autoPlayVideos && 'autoplay'} preload="none" data-poster={video.preview_image.src}>
            {video.sources.map(videoSource => (
                <source src={videoSource.url} type={videoSource.mime_type} />
            ))}
        </video>
    )
}

const FeaturedItemVideoIframe = ({ video }) => {
    const { customConfig } = useCustomConfig()
    const embedId = video.external_id || video.id;
    const allowYoutube = autoPlayVideos ? ['autoplay', ...youtubeAllowances] : youtubeAllowances;
    const allowVimeo = autoPlayVideos ? ['autoplay', ...vimeoAllowances] : vimeoAllowances;
    const srcYoutube = `//www.youtube.com/embed/${embedId}?autohide=1&cc_load_policy=0&controls=1${autoPlayVideos ? `&autoplay=1&mute=1&loop=1&playlist=${embedId}` : ''}&fs=1&iv_load_policy=3&modestbranding=1&playsinline=1&rel=0&enablejsapi=1&origin=${customConfig.shop.url}&widgetid=1`
    const srcVimeo = `//player.vimeo.com/video/${embedId}?title=${video.title}0&byline=0&controls=1${autoPlay ? '&autoplay=1&muted=1&loop=1' : ''}`
    return (
        video.type === 'youtube' ? 
            <iframe 
                className="media js-youtube" 
                data-type="youtube" 
                data-video-id={embedId} 
                frameborder="0" 
                allowfullscreen={true} 
                allow={allowYoutube.join(';')} 
                title={video.title} 
                width="1280" 
                height="720" 
                src={srcYoutube} tabindex="-1"></iframe>
        :
            <iframe 
                className="media js-vimeo" 
                src={srcVimeo} 
                width="480" 
                height="270" 
                frameborder="0" 
                allow={allowVimeo.join(';')} 
                allowfullscreen={true} 
                title={video.title} 
                data-ready="true" tabindex="-1"></iframe>
    )
}

const FeaturedItemMedia = ({ data }) => {
    if (data.video_mp4) {
        return <FeaturedItemVideo video={{ title: data.title, ...data.video_mp4 }} />
    } else if (data.video_iframe) {
        return <FeaturedItemVideoIframe video={{ title: data.title, ...data.video_iframe }} />
    } else {
        return <FeaturedItemImage image={{ title: data.title, src: data.image.src, width: data.image.width, height: data.image.height }} />
    }
}

const FeaturedItemWrapper = ({ data, children }) => {

    const wrapClass = `wrap scheme no-highlight-hover flex ${data.text_position} text-${data.text_align} color-${data.content_color_scheme}`

    return (
        data.link && !data.button ? 
            <a class={wrapClass} href={data.link}>{children}</a>
        :
            <div class={wrapClass}>{children}</div>
    )
}

export default function FeaturedItem ({ data }) {

    const { settings: featuredItem } = data

    const mainClass = `collage-item trigger-floating-buttons grid-item block-${data.block_id} tint-${featuredItem.tint_type} ${featuredItem.image && 'has-image'} ${featuredItem.width} ${featuredItem.custom_class ? featuredItem.custom_class : ''}`
    const titleClass = `title h${featuredItem.title_size.toString().replace('0', '1-xl').replace('-1', '1-xxl')}`
    const textClass = `text p${featuredItem.text_size}`
    const buttonClass = `cta ${featuredItem.cta_style} ${featuredItem.cta_size}`

    return (
        <div className={mainClass}>
            <FeaturedItemWrapper data={featuredItem}>                
                <FeaturedItemMedia data={featuredItem} />
                <div class="captions ">
                    {featuredItem.title && <div className={titleClass}>{featuredItem.title}</div>}
                    {featuredItem.text && featuredItem.text != '<p></p>' && <div className={textClass} dangerouslySetInnerHTML={{ __html: featuredItem.text }}></div>}
                    {featuredItem.button && <a className={buttonClass} href={featuredItem.link}>{featuredItem.button}</a>}
                </div>
            </FeaturedItemWrapper>
        </div>
    )
}